export default __webpack_public_path__ + "static/business-onboarding-71ee5a30c73f93f42aaf82ed77e1b308.png";